import React, { Component } from 'react'
import Slider from "react-slick";
import getConfig from 'next/config';
import { Container } from 'react-bootstrap';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();

export default class index extends Component {
    render() {
        var settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            arrows: false
        };
        return (
            <div id="people-saying" className="mb-sm-3">
                <Slider {...settings}>
                    <div className="slick-psd text-center pb-sm-5 mobile-people">
                         <img src={`${publicRuntimeConfig.staticFolder}/images/srikanth.png`} alt="dev-group" className="mt-sm-3 pt-sm-2 m-auto " />
                        <div className="footer-nav sri-font pt-4">Srikanth Tirumala</div>
                        <div className="talk-content sri-desingation">Founder and CEO, Hooperlabs Inc.</div>
                        <div className="footer-nav-link pt-4">
                                AxlrData has been very pivotal to our web presence. The team was very agile 
                                and <br className="desktop" /> responsive to our requirements. They made it possible for us to make our 
                                product <br className="desktop" /> standout at the MWC, 2019. Following this, we’ve worked with on several 
                                other <br className="desktop" /> projects and have found it delightful to engage with this young and 
                                dynamic team.
                        </div>
                    </div>
                </Slider>
                <style jsx global>
                    {
                        `
                        body{
                            overflow-x: hidden
                        }
                    .slick-slider-card{
                        box-shadow: 0 10px 30px 0px rgba(0, 0, 0, 0.05);
                        padding:20px;
                        z-index:99999999;
                        background:#fff;
                        border-radius: 5px;
                    }
                    .slick-psd{
                        padding: 20px 10px;

                    }
                    .slick-psd:focus{
                        outline: none;
                    }
                    .slick-psd1{
                        padding: 20px;
                    }
                    .cust-logo{
                        width: 150px;
                    }
                    .mhjd{
                        margin-top: -60px;
                    }
                    .sri-desingation{
                        line-height: 5px;
                        font-size: 10px;
                        margin-bottom: 16px;
                    }
                    .sri-font{
                        font-size: 25px !important;
                    }
                    `
                    }
                </style>
            </div>
        )
    }
}
